const getters = {
    token: state => state.user.token,
    name: state => state.user.email,
    is_superuser: state=> state.user.is_superuser,
};

export default getters
